export default "__VITE_ASSET__Cdszzra$__"